import { useContext } from 'react';

import { LoginPageContext } from './LoginPageContext';
import { RootContext } from './RootContext';
import { SigningPageContext } from './SigningPageContext';

export const useIncomeSigningPageContext = () => useContext(SigningPageContext);
export const useIncomeInsuranceRootContext = () => useContext(RootContext);
export const useIncomeInsuranceLoginPageContext = () =>
  useContext(LoginPageContext);
